import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Button, Form, Table, Spinner } from "react-bootstrap";
import { FaPlus, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { getSESProducts, setSIVProductInventoryTransaction } from '../../actions';

class ProductInventoryTransactionEdit extends Component {
  state = {
    loading: false,
    type: 'IMPORT', // 'IMPORT' or 'EXPORT'
    partner_id: '',
    transaction_date: new Date().toISOString().split('T')[0], // Default to today
    items: [
      {
        product_code: '',
        quantity: 0
      }
    ],
    system_note: '',
    staff_note: '',
    saving: false
  };

  componentDidMount() {
    // Load products with default pagination
    this.props.getSESProducts({
      currentPage: 1,
      itemsPerPage: 100,
      sortBy: 'product_code',
      sortOrder: 1
    });
  }

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  handlePartnerChange = (e) => {
    this.setState({ partner_id: e.target.value });
  };

  handleTransactionDateChange = (e) => {
    this.setState({ transaction_date: e.target.value });
  };

  handleAddItem = () => {
    this.setState(prevState => ({
      items: [...prevState.items, { product_code: '', quantity: 0 }]
    }));
  };

  handleRemoveItem = (index) => {
    this.setState(prevState => ({
      items: prevState.items.filter((_, i) => i !== index)
    }));
  };

  handleItemChange = (index, field, value) => {
    this.setState(prevState => ({
      items: prevState.items.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  handleNoteChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { type, partner_id, transaction_date, items, system_note, staff_note } = this.state;
    
    // Validate
    if (items.some(item => !item.product_code || item.quantity <= 0)) {
      alert('Please fill in all product codes and quantities');
      return;
    }

    this.setState({ saving: true });

    // Prepare data for API
    const transaction = {
      type,
      partner_id,
      transaction_date,
      system_note,
      staff_note,
      items: items.map(item => ({
        product_code: item.product_code,
        quantity_change: type === 'IMPORT' ? item.quantity : -item.quantity
      }))
    };

    this.props.setSIVProductInventoryTransaction(transaction)
      .then(() => {
        alert('Successfully saved transaction');
        this.props.history.push('/admin/fulfill/transactions');
      })
      .catch(error => {
        console.error('Error saving transaction:', error);
        alert('Failed to save transaction. See console for details.');
        this.setState({ saving: false });
      });
  };

  render() {
    const { type, partner_id, transaction_date, items, system_note, staff_note, saving } = this.state;
    const { products } = this.props;

    const productOptions = products ? products.map(product => ({
      value: product.product_code,
      label: `${product.product_code} - ${product.product_name}`
    })) : [];

    const partnerOptions = type === 'IMPORT' 
      ? [
          { value: 'RESIN_HOAI_DUC', label: 'RESIN HOÀI ĐỨC' },
          { value: 'BREAKWOODEN', label: 'BREAKWOODEN' }
        ]
      : [
          { value: 'SAIGONBAY', label: 'SAIGONBAY' },
          { value: 'VIETTEL_POST', label: 'VIETTEL POST' },
          { value: 'OTHER', label: 'OTHER' }
        ];

    return (
      <Container fluid>
        <h2 className="text-center mb-4">Create Inventory Transaction</h2>

        <Row className="mb-4">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Type</Form.Label>
              <Form.Select
                value={type}
                onChange={this.handleTypeChange}
              >
                <option value="IMPORT">Import</option>
                <option value="EXPORT">Export</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Partner</Form.Label>
              <Form.Select
                value={partner_id}
                onChange={this.handlePartnerChange}
              >
                <option value="">Select a partner</option>
                {partnerOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Transaction Date</Form.Label>
              <Form.Control
                type="date"
                value={transaction_date}
                onChange={this.handleTransactionDateChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Product Code</th>
              <th>Quantity</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>
                  <Select
                    value={productOptions.find(option => option.value === item.product_code)}
                    onChange={(option) => this.handleItemChange(index, 'product_code', option ? option.value : '')}
                    options={productOptions}
                    isClearable
                    placeholder="Select a product..."
                    noOptionsMessage={() => "No products found"}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    value={item.quantity}
                    onChange={(e) => this.handleItemChange(index, 'quantity', parseInt(e.target.value) || 0)}
                    min="1"
                  />
                </td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => this.handleRemoveItem(index)}
                    disabled={items.length === 1}
                  >
                    <FaTrash /> Remove
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Row className="mb-4">
          <Col>
            <Button
              variant="primary"
              onClick={this.handleAddItem}
            >
              <FaPlus /> Add Item
            </Button>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label>System Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="system_note"
                value={system_note}
                onChange={this.handleNoteChange}
                placeholder="Enter system notes..."
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label>Staff Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="staff_note"
                value={staff_note}
                onChange={this.handleNoteChange}
                placeholder="Enter staff notes..."
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col className="text-end">
            <Button
              variant="secondary"
              onClick={() => this.props.history.push('/admin/fulfill/transactions')}
              className="me-2"
            >
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={this.handleSubmit}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Saving...
                </>
              ) : (
                'Save'
              )}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state.sesProductReducer.products
});

export default connect(mapStateToProps, {
  getSESProducts,
  setSIVProductInventoryTransaction
})(ProductInventoryTransactionEdit); 